export default __webpack_public_path__ + "static/media/gilroy-regular.f7f5960c.otf";